<template>
	<!-- <div class="header" :style="{ backgroundImage: `url(${headInfo.file_url})` }"> -->
	<div class="header" :class="page == '设置' ? 'header-set' : ''">
		<!-- <div class="hearder-bg"><img :src="headerBg || ''" alt=""></div> -->
		<div class="head clearfix">
			<div style="border-bottom: 1px solid rgba(255, 255, 255, 0.2)">
				<div class="head-top">
					<div class="head-logo">
						<a href="index.html"><img :src="logoUrl" alt=""/></a>
					</div>
					<div class="head-infor" v-if="showLogin">
						<div class="app-link">
							<span class="guard-center">下载APP</span>
							<div class="app-code">
								<img src="../../assets/images/app.png" alt="" />
							</div>
						</div>
						<a
							v-show="headList.length && (zhsRole == 1)"
							class="guard-center"
							v-for="(item, index) in headList"
							:key="index"
							:href="item.target_url ? item.target_url : ''"
							:target="item.target_type ? '_blank' : '_self'"
							>{{ item.name }}</a
						>
						<a
							v-if="onlineTeache && (zhsRole || userRole)"
							class="online"
							:href="onlineTeache ? onlineTeache.target_url : ''"
							target="_blank"
							>{{ onlineTeache.name }}</a
						>
						<a
							class="online"
							:href="backUrl"
							v-if="userInfo && userInfo.roleList && userInfo.roleList.length"
							@click="goBackPlat"
							target="_blank"
							>管理后台</a
						>
						<!-- 未登录时 -->
						<div v-if="!userInfo" class="head-login" @click="zhsLogin">
							登录
						</div>
						<!-- 登录时 -->
						<div v-else class="head-user">
							<img
								class="avatar"
								:src="
									userInfo.avatar
										? userInfo.avatar
										: require('../../assets/images/user_icon.png')
								"
							/>
							<span class="user-name">{{ userInfo.realname }}</span>
							<div class="toggle-arrow-span"></div>
							<div class="logout-wrapper">
								<a :href="`/setting.html?id=${teacherMenuId}`">
									<div class="link">账号设置</div>
								</a>
								<div @click="logout">
									<div class="link">退出</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 导航栏 -->
			<div class="head-btn" :class="page == '设置' ? 'btn-none' : ''">
				<div class="head-nav">
					<!-- <div v-for="({ name, link }, index) in navList" :key="index" class="nav-btn" :class="page === name ? 'nav-active' : ''">
            <a :href="link" class="noticenav">{{ name }}</a>
          </div> -->
					<div
						v-for="({ menu_name, target_url, target_type }, index) in navList.slice(
							0,
							10
						)"
						:key="index"
						class="nav-btn"
						:class="currentPage === menu_name ? 'nav-active' : ''"
					>
						<a
							:href="target_url"
							class="noticenav"
							:target="target_type ? '_blank' : '_self'"
							>{{ menu_name }}</a
						>
					</div>
				</div>
			</div>
			<!-- 返回顶部 -->
			<div class="fixPostion">
				<div class="back-top" @click="backTop">
					<i class="el-icon-arrow-up"></i>
				</div>
			</div>
		</div>
		<!-- <div id="CaptchaEl" ref="CaptchaEl" data-appid="2036785952" data-cbfn="captchaCb" data-module="0" type="primary" style="display: none;"> -->
		<!-- </div> -->
	</div>
</template>
<script>
import './../css/head.css';
import axios from 'axios';
export default {
	props: {
		menuInfo: {
			type: Object,
		},
		page: {
			type: String,
			default: '首页',
		},
		searchText: String,
		isNeedLogin: {
			type: Boolean,
			default: false,
		},
		menuCode: String || Number,
	},
	created() {
		this.getObjectStatus();
		this.getUserInfo();
		this.getNavList();
	},
	mounted() {
		this.getBaseSet();
		this.addPv();
		window.addEventListener('scroll', this.handleScroll, true);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	data() {
		return {
			isFocus: false, // 是否获得焦点
			keyword: this.searchText,
			headInfo: {},
			userInfo: null,
			moocMenu: {},
			spocMenu: {},
			teacherMenu: {},
			newMenu: {},
			logoUrl: '',
			navList: [],
			headerBg: '',
			footer: '',
			url: location.href.substring(location.href.indexOf('?') + 1),
			centerList: [],
			headList: [],
			onlineTeache: null,
			currentPage: '首页',
			userRole: 0,
			zhsRole: 0,
			linkNav: [], // 导航中的外部链接
			teacherMenuId: '',
			showLogin: false,
			backUrl: `//${process.env.VUE_APP_HOST}/admin/`,
		};
	},
	computed: {
		config() {
			return this.$config;
		},
		CurrentUrl() {
			return this.page || window.location.href;
		},
		loginUrl() {
			return `/index.html`;
		},
		noTicketUrl() {
			return this.$utils.removeUrlParam(['ticket']);
		},
	},
	methods: {
		zhsLogin() {
			const host = window.location.protocol + '//' + window.location.host;
			const loginUrl = host + '/index.html';
			const url = host + '/index.html';
			window.location.href = `${host}/hike-boot/AuthSys/getAuthorize?redirectUri=${url}&failRedirectUri=${loginUrl}`;
			// window.location.href = `https://passport.zhihuishu.com/login?service=${this.url}`;
		},
		// 关键字搜索
		handleSearch() {
			if (this.keyword) {
				window.location.href = `/search.html?keyword=${this.keyword}`;
			}
		},
		// ticket校验
		async validTicket() {
			const params = {
				service: this.noTicketUrl,
				ticket: this.$utils.getUrlParams('ticket'),
			};
			const validInfo = await this.$http.validateTicket(params);
			if (validInfo.token) this.$utils.setCookie('X-Access-Token', validInfo.token);
			if (validInfo.userInfo) {
				this.userInfo = validInfo.userInfo;
				this.$emit('getUserInfo', this.userInfo);
				if (this.userInfo.uuid) {
					this.getUserZhsRole();
					this.getUserIdentity();
				}
			}
			// 是否需要登录
			if (!validInfo && this.isNeedLogin) {
				window.location.href = loginUrl;
			}
		},
		// 获取用户信息
		async getUserInfo() {
			let token = this.$utils.getCookie('X-Access-Token');
			let ticket = this.$utils.getUrlParams('ticket');
			if (token) {
				const userInfo = await this.$http.getUserInfo();
				this.userInfo = userInfo;
				console.log('用户信息', userInfo);
				if (this.userInfo.uuid) {
					this.getUserZhsRole();
					this.getUserIdentity();
				}
				this.$emit('getUserInfo', userInfo);
				return;
			}
			if (ticket) {
				this.validTicket();
				return;
			}
			// 是否需要登录
			if (this.isNeedLogin) {
				window.location.href = '/index.html';
			}
			return null;
		},
		// 获取用户智慧树学校角色
		async getUserIdentity() {
			let params = {
				schoolId: this.config.schoolId,
				uuid: this.userInfo.uuid,
			};
			const res = await this.$http.getUserIdentity(params);
			console.log('智慧树身份', res);
			this.userRole = res;
		},
		async getUserZhsRole() {
			const res = await this.$http.getUserZhsIdentity({
				uuid: this.userInfo.uuid,
			});
			console.log('智慧树角色', res);
			this.zhsRole = res.role;
		},
		async logout() {
			try {
				let token = this.$utils.getCookie('X-Access-Token');
				if (token) {
					await this.$http.logout();
					this.$utils.delCookie('X-Access-Token');
					this.zhsLogout();
				} else {
					window.location.href = `/index.html`;
				}
			} catch (e) {
				console.log(e);
			}
		},
		// 智慧树退出登录
		zhsLogout() {
			// service 智慧树退出登录
			axios
				.post('//oauth.zhihuishu.com/logout')
				.then((res) => {
					console.log(res);
				})
				.catch((error) => {
					console.log(error);
				});
			window.location.href = `//passport.zhihuishu.com/logout?service=https://${process.env.VUE_APP_HOST}/index.html`;
		},

		async getNavList() {
			const res = await this.$http.getNavList(); // 导航
			const res2 = await this.$http.getConfigList(); // 登录权限
			const res3 = await this.$http.getObjectOpen(); // 项目已开启功能
			this.centerList = res3.filter((item) => item.type == '2');
			sessionStorage.setItem('authInfo', JSON.stringify(res2)); // 详情页判断登录用
			// 账号设置页用到
			this.teacherMenuId = res.find((item) => item.menu_code == '10501')
				? res.find((item) => item.menu_code == '10501').id
				: '';
			this.showLogin = res3.some((item) => item.code == '10000');
			this.linkNav = res.filter((item) => item.menu_type == 4);
			// 菜单需登录
			let list = JSON.parse(JSON.stringify(res));
			const menu = res2.filter((i) => i.auth_type == 5);
			let newArr = [];
			menu.forEach((item) => newArr.push(item.code));
			let dataList = list;
			if (!this.userInfo) {
				dataList = res.filter((item) => !newArr.includes(item.menu_code));
			}
			const i = res2.findIndex((i) => i.code == this.menuCode);
			const { auth_type } = res2[i] || {};
			this.$emit('authType', auth_type);
			const urlList = {
				10301: '/index.html',
				10401: '/courseList.html?type=1',
				10402: '/courseList.html?type=2',
				10501: '/teacherList.html',
				10601: '/live.html',
				10701: '/notice.html',
			};
			if (auth_type === 3 && !this.userInfo) {
				window.location.href = `/index.html`;
			}
			// 点击导航跳转到对应taget_url,并传参
			const data = dataList.map((item) => ({
				...item,
				target_url: item.target_url
					? item.target_url
					: item.menu_code == 10401 || item.menu_code == 10402
					? `${urlList[item.menu_code]}&menuId=${item.id}&name=${item.menu_name}`
					: `${urlList[item.menu_code]}?menuId=${item.id}&name=${item.menu_name}`,
			}));
			this.navList = data;
			// 当前页面 导航高亮
			const currentPageIndex =
				(this.navList || []).findIndex(
					(item) => item.id === this.$utils.getUrlParams('menuId')
				) || 0;
			if (this.navList[currentPageIndex]) {
				this.currentPage = this.navList[currentPageIndex].menu_name;
				this.$emit('update:menuInfo', this.navList[currentPageIndex]);
			}
			// 头部指挥中心等按钮展示规则
			// if (this.linkNav.length) {
				let arr = [];
				this.linkNav.forEach((item) => arr.push(item.menu_code));
				this.headList = this.centerList.filter(
					(item) => !arr.includes(item.code) && item.code !== '16001'
				);
				// console.log('this.headList', this.headList);
				this.onlineTeache = this.centerList.find((item) => item.code == '16001');
			// }
		},
		// 基础配置信息
		async getBaseSet() {
			const res = await this.$http.getBaseSet();
			this.logoUrl = res.home_logo_url || require('../../assets/images/logo.png');
			this.headerBg = res.back_logo_url;
			// 浏览器图标
			var link =
				document.querySelector("link[rel*='icon']") || document.createElement('link');
			link.type = 'image/x-icon';
			link.rel = 'shortcut icon';
			link.href = res.icon_url;
			document.getElementsByTagName('head')[0].appendChild(link);
		},
		// 访问量
		async addPv() {
			let params = {};
			const res = await this.$http.addPv(params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
		},
		// 项目状态
		async getObjectStatus() {
			const res = await this.$http.getObjectStatus();
			console.log('状态', res);
			if (res.status == '0') {
				window.location.href = '/stop.html';
			}
		},
		// 返回顶部
		backTop() {
			let timer = setInterval(() => {
				let ispeed = Math.floor(-this.scrollTop / 5);
				document.documentElement.scrollTop = document.body.scrollTop =
					this.scrollTop + ispeed;
				if (this.scrollTop === 0) {
					clearInterval(timer);
				}
			}, 20);
		},
		handleScroll() {
			let scrollTop =
				window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			this.scrollTop = scrollTop;
		},
	},
};
</script>
<style lang="scss" scoped>
.header {
	position: relative;
	height: 130px;
	// background: rgba($color: $--color-primary, $alpha: 0.9);
	background: $--color-primary;
	background-size: auto 100%;
}
.head-login {
	float: right;
	width: 87px;
	height: 40px;
	line-height: 40px;
	padding: 0 15px;
	border-radius: 20px;
	border: 1px solid rgba(255, 255, 255, 0.2);
	position: relative;
	cursor: pointer;
	font-size: 14px;
	color: #ffffff;
	text-align: center;
	&:hover {
		background-color: rgba(0, 0, 0, 0.2);
	}
}

.head-user {
	float: right;
	width: 140px;
	height: 40px;
	background: rgba(0, 0, 0, 0.3);
	border-radius: 20px;
	padding-left: 12px;
	line-height: 40px;
	position: relative;
	display: flex;
	align-items: center;
}

.head-user .avatar {
	width: 26px;
	height: 26px;
	border-radius: 50%;
}

.head-user .user-name {
	font-size: 14px;
	color: #ffffff;
	max-width: 60px;
	display: inline-block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin: 0 10px;
}
.head-user:hover .logout-wrapper {
	display: block;
}
.head-user:hover .toggle-arrow-span {
	transform: rotateX(180deg);
	margin-top: 0;
}
.toggle-arrow-span {
	background: url(//image.zhihuishu.com/zhs_yufa_150820/ablecommons/demo/202103/a4f6463ff4e14735b117539229d6a248.png)
		no-repeat;
	background-size: 45% 45%;
	width: 20px;
	height: 12px;
	margin-top: 10px;
}

.logout-wrapper {
	display: none;
	background: #ffffff;
	border-radius: 4px;
	width: 132px;
	height: auto;
	padding-left: 20px;
	position: absolute;
	top: 35px;
	right: 0;
	z-index: 99;
}

.logout-wrapper .link {
	text-align: left;
	line-height: 49px;
	cursor: pointer;
	width: 108px;
	font-size: 14px;
	color: #333333;
	&:hover {
		color: $--color-primary;
	}
}

.fixPostion {
	display: flex;
	flex-wrap: wrap;
	position: fixed;
	bottom: 50px;
	right: 10px;
	z-index: 999;
	width: 44px;
	height: 100px;
	.back-top {
		width: 100%;
		height: 46px;
		position: relative;
		border-radius: 4px;
		padding: 6px;
		background-color: #f5f5f5;
		font-size: 14px;
		color: #999999;
		font-weight: 400;
		&:hover {
			color: #333;
		}
	}
	.back-top {
		padding-top: 16px;
		text-align: center;
	}
}

.hearder-bg {
	position: absolute;
	top: 0;
	left: 0;
	img {
		width: 100%;
		height: 130px;
		object-fit: cover;
	}
}
.head-top {
	width: 1200px;
	height: 80px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.head-logo {
	float: left;
	box-sizing: content-box;
}

.head-logo a {
	display: block;
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.head-logo img {
	// width: 260px;
	height: 44px;
}

.head-infor {
	float: right;
	display: flex;
	.guard-center {
		display: inline-block;
		margin-right: 20px;
		height: 40px;
		padding: 0 15px;
		border-radius: 20px;
		border: 1px solid rgba(255, 255, 255, 0.2);
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		color: #ffffff;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		&:hover {
			background-color: rgba(0, 0, 0, 0.2);
		}
	}
	.online {
		display: block;
		margin-right: 20px;
		width: 97px;
		// height: 40px;
		padding: 0 15px;
		border-radius: 20px;
		border: 1px solid rgba(255, 255, 255, 0.2);
		// background: rgba(255,255,255, .2);
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		color: #ffffff;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		&:hover {
			background-color: rgba(0, 0, 0, 0.2);
		}
	}
}

.app-link {
	position: relative;
	.app-code {
		display: none;
		position: absolute;
		bottom: -205px;
		left: -115px;
		z-index: 1000;
		padding-top: 10px;
		img {
			width: 320px;
		}
	}
	&:hover {
		.app-code {
			display: block;
		}
	}
}

.head-search {
	width: 200px;
	height: 40px;
	background-color: #092150;
	float: left;
	position: relative;
	margin-right: 34px;
	border-radius: 20px;
	border: 1px solid transparent;
}

.head-search input {
	display: block;
	width: 161px;
	height: 100%;
	padding: 8px 35px 8px 14px;
	border: 0;
	font-size: 14px;
	color: #fff;
	border-radius: 20px;
	background: #092150;
	outline: none;
}

.head-search input::placeholder {
	color: #9caac7;
}

.search-btn {
	font-size: 14px;
	right: 16px;
	position: absolute;
	top: 50%;
	transform: translateY(-7px);
	color: rgba(255, 255, 255, 0.65);
	cursor: pointer;
}

.head-search-focus {
	border-color: #fff;
}

.head-search-focus .search-btn {
	color: #fff;
}
.head-btn {
	background: $--color-primary;
	.head-nav {
		width: 1200px;
		margin: 0 auto;
		height: 50px;
		font-size: 0;
		.nav-btn {
			width: 120px;
			height: 50px;
			display: inline-block;
			text-align: center;
			// & + .nav-btn {
			//   // margin-left: 34px;
			// }
			&.nav-active,
			&:hover {
				background-color: rgba(0, 0, 0, 0.2);
			}
			a {
				color: #fff;
				font-size: 14px;
				display: inline-block;
				line-height: 20px;
				padding: 14px 0 10px;
				border-bottom: 1px solid transparent;
			}
		}
	}
}
.btn-none {
	display: none;
}
.header-set {
	height: 80px;
}
</style>
